(function () {
  'use strict';

  angular.module('app').service('IncomingPrepaymentModalService', IncomingPrepaymentModalService);

  IncomingPrepaymentModalService.$inject = ['CONFIGURATIONS', 'ModalService'];

  function IncomingPrepaymentModalService(config, ModalService) {
    let preventModalClose = {
      backdrop: 'static',
      keyboard: false,
    };

    let service = {
      openAddIncomingPrepayment: openAddIncomingPrepayment,
    };

    return service;

    // --------------------------- addIncomingPrepayment -------------------------

    function openAddIncomingPrepayment(
      item,
      index,
      incomingPrepayments,
      incomingPrepaymentsTotalPercentage,
      successCallback
    ) {
      ModalService.showModal({
        templateUrl:
          './app/ajs/prepayment-reports/incoming-prepayments/modals/add-incoming-prepayment-modal.html',
        controller: openAddIncomingPrepaymentCtrl,
        controllerAs: 'vm',
        inputs: {
          item: item,
          index: index,
          incomingPrepayments: incomingPrepayments,
          incomingPrepaymentsTotalPercentage: incomingPrepaymentsTotalPercentage,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal(preventModalClose);
      });

      openAddIncomingPrepaymentCtrl.$inject = [
        '$element',
        'item',
        'index',
        'incomingPrepayments',
        'incomingPrepaymentsTotalPercentage',
        'successCallback',
      ];
    }

    function openAddIncomingPrepaymentCtrl(
      $element,
      item,
      index,
      incomingPrepayments,
      incomingPrepaymentsTotalPercentage,
      successCallback
    ) {
      let vm = this;

      vm.booking = item;
      vm.index = index;
      vm.incomingPrepayments = incomingPrepayments;
      vm.incomingPrepaymentsTotalPercentage = incomingPrepaymentsTotalPercentage;

      // Public methods
      vm.onIncomingPrepaymentSaved = function (incomingPrepayment) {
        $element.modal('hide');
        successCallback(incomingPrepayment);
      };
    }
  }
})();
